var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-namespace */
import React, { createRef, useEffect } from 'react';
import isMobile from 'ismobilejs';
export const DatePicker = (props) => {
    const ref = createRef();
    const { format, value = '', // not use this shit
    minDate, maxDate, defaultDate, disabledRanges = [], allowInput, onClose, onOpen, onChange, className, 
    // textfield props
    raised, invalid, small, big, fluid, iconAtRight, loading, icon } = props, nativeProps = __rest(props, ["format", "value", "minDate", "maxDate", "defaultDate", "disabledRanges", "allowInput", "onClose", "onOpen", "onChange", "className", "raised", "invalid", "small", "big", "fluid", "iconAtRight", "loading", "icon"]);
    const open = () => onOpen();
    const close = (ev) => onClose(ev.detail);
    const select = (ev) => {
        if (ev.detail) {
            onChange(...ev.detail);
        }
    };
    useEffect(() => {
        // console.log('%c Mount', 'color: #09c; font-weight: 600')
        ref.current.defaultDate = defaultDate;
        if (isMobile().any) {
            // ref.current.value = value
        }
        ref.current.minDate = minDate;
        ref.current.maxDate = maxDate;
        return () => {
            // console.log('%c Destroy', 'color: #d53400; font-weight: 600')
            const datePicker = ref.current;
            if (datePicker) {
                datePicker.destroy();
            }
        };
    }, []);
    useEffect(() => {
        // console.log('%c Bind listeners', 'color: #09c; font-weight: 600')
        const datePicker = ref.current;
        datePicker.addEventListener('open', open);
        datePicker.addEventListener('close', close);
        datePicker.addEventListener('select', select);
        return () => {
            // console.log('%c Unbind listeners', 'color: #ff6319; font-weight: 600')
            datePicker.removeEventListener('open', open);
            datePicker.removeEventListener('close', close);
            datePicker.removeEventListener('select', select);
        };
    });
    useEffect(() => {
        // Inject disabled ranges into web component
        disabledRanges.forEach((range) => {
            if (ref.current) {
                ref.current.disableRangeBetween(range);
            }
        });
    }, [disabledRanges]);
    return (React.createElement("puk-datepicker", { raised: raised, invalid: invalid, small: small, big: big, fluid: fluid, loading: loading, iconAtRight: iconAtRight, 
        // defaultDate={defaultDate}
        format: format, allowInput: allowInput, 
        // minDate={minDate}
        // maxDate={maxDate}
        cssClass: className, ref: ref },
        React.createElement("input", Object.assign({}, nativeProps, { type: "date", slot: "input" })),
        icon ? React.cloneElement(icon, { 'data-icon': '' }) : null,
        React.createElement("div", { className: "loadingAnimation" },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
};
DatePicker.defaultProps = {
    onOpen: () => { },
    onClose: () => { },
    onChange: () => { },
    allowInput: false,
    format: 'd/m/Y',
    minDate: null,
    maxDate: null,
    defaultDate: null,
    disabledRanges: [],
    loading: false,
    big: false,
    small: false,
    raised: false,
    invalid: false,
    className: ''
};
